const prefix = 'TABLE_';

export const INIT_STATE = `${prefix}INIT_STATE`;

export const FETCH_TABLE = `${prefix}FETCH`;
export const FETCH_TABLE_FULFILLED = `${prefix}FETCH_FULFILLED`;
export const FETCH_TABLE_ERROR = `${prefix}FETCH_ERROR`;

export const FETCH_COUNT = `${prefix}FETCH_COUNT`;
export const FETCH_COUNT_FULFILLED = `${prefix}FETCH_COUNT_FULFILLED`;

export const SET_PAGINATION = `${prefix}SET_PAGINATION`;
export const SET_LOADING = `${prefix}SET_LOADING`;
